var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "loginForm", staticClass: "login-form" }, [
    _c("div", {
      staticClass: "logo",
      domProps: { innerHTML: _vm._s(_vm.logo) },
    }),
    _vm._v(" "),
    _c(
      "form",
      {
        staticClass: "form",
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.onFormSubmit($event)
          },
        },
      },
      [
        _vm.responseCheckDuration
          ? _c("div", [
              _c(
                "div",
                {
                  staticClass: "message error",
                  staticStyle: { "font-weight": "bold", "font-size": "17px" },
                },
                [_vm._v("\n        Echec - Délai d'attente dépassé\n      ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "message info",
                  staticStyle: { "font-size": "16px" },
                },
                [
                  _vm._v(
                    "\n        Veuillez recommencer la procédure de réinitialisation du mot de passe.\n      "
                  ),
                ]
              ),
            ])
          : _c(
              "div",
              [
                _c("div", { staticClass: "messages" }, [
                  !!_vm.infoMessage
                    ? _c("div", { staticClass: "message info show" }, [
                        _c("i", {
                          staticClass: "fa fa-times",
                          on: {
                            click: function () {
                              return (_vm.infoMessage = null)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("i", {
                          staticClass: "fa fa-exclamation-circle indicator",
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "message-inner" }, [
                          _c("span", [_vm._v(_vm._s(_vm.infoMessage))]),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.errorMessages.length > 0
                    ? _c(
                        "div",
                        { staticClass: "message error show" },
                        [
                          _c("i", {
                            staticClass: "fa fa-times",
                            on: {
                              click: function () {
                                return (_vm.errorMessages = [])
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("i", {
                            staticClass: "fa fa-exclamation-circle indicator",
                          }),
                          _vm._v(" "),
                          _vm._l(_vm.errorMessages, function (message, idx) {
                            return _c(
                              "div",
                              { key: idx, staticClass: "message-inner" },
                              [_c("span", [_vm._v(_vm._s(message))])]
                            )
                          }),
                        ],
                        2
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("PassordFields", {
                  on: { passwordValidity: _vm.onPasswordValidity },
                }),
                _vm._v(" "),
                _c(
                  "Btn",
                  {
                    class: [
                      "mt-3 default block submit-button",
                      !_vm.isPasswordValid ? "disabled" : "",
                    ],
                    nativeOn: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.onFormSubmit($event)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("login.loginBtn")) +
                        "\n      "
                    ),
                  ]
                ),
              ],
              1
            ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }